import React, { memo, useEffect } from 'react'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useFormValidation } from '../../../hooks/useFormValidation'
import { enumActions, initEmptyData } from '../../../store/actions/modelsActions/control'
import { buildControlsExt, selectInput } from '../../inputs/controls'
import { PATH_JOINER } from '../utils/getConfigBitPath'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { selectConfigBit } from '../../../store/selectors/configSelectors'
import { getLabel } from '../../../utils/getLabel'

export interface IEnumProps {
    dataPath: string
    dataSchema: any
    name: string
    wrapper?: string
}

export const Enum = memo(function Enum({
  dataPath,
  dataSchema = {},
  name,
  wrapper,
}: IEnumProps) {
  const dispatch = useAppDispatch()
  const configBit = useAppSelector(selectConfigBit(dataPath.split(PATH_JOINER)))

  const path = [...(dataPath.split(PATH_JOINER)), name]
  const [inputState, setInputState, touched, setTouched] = useFormValidation(configBit, {})
  const label: string = getLabel(name, dataSchema.name)
  const className: string = !wrapper ? 'w-50 pe-2' : ''
  const selected = Object.entries(dataSchema.options).find((option) =>
    option.find((el) => el === configBit?.[name])
  )?.[0]

  useEffect(() => {
    if (configBit && dataPath.length) {
      setInputState({ configBit, [name]: selected })
    }
  }, [configBit]) // eslint-disable-line

  useEffect(() => {
    if (dataPath.length) {
      if (
        !configBit ||
        !Object.keys(configBit).length ||
        typeof configBit?.[name] === 'undefined'
      ) {
        dispatch(initEmptyData({ schema: dataSchema, name, path }))
      }
    }
  }, []) // eslint-disable-line

  useEffect(() => {
    if (Object.keys(touched).length && dataPath.length) {
      dispatch(enumActions.modify(inputState[name], path, inputState[name]))
    }
  }, [inputState]) // eslint-disable-line

  const controlDescriptors =  [
      selectInput({
          name,
          options: Object.keys(dataSchema.options),
          selected: configBit?.[name] || dataSchema?.default || 0,
          tooltipText: dataSchema.description,
          changeWarning: dataSchema.change_warning,
          label,
          className,
          isColumn: true,
      }),
  ]

  const EnumInput = buildControlsExt(
      controlDescriptors,
      inputState,
      setInputState,
      touched,
      setTouched,
  )

  return <div className={`${!wrapper ? 'w-100' : ''}`}>{EnumInput}</div>
})